import type { Dish } from '@lemontaigu/shared';
import { getMenuStore } from './store.js';

/** Active, non-deleted daily dishes served on `dateIso` (the Menu du Jour for that day). */
export function panelDishes(dateIso: string): Promise<Dish[]> {
  return getMenuStore().panelDishes(dateIso);
}

/** Serve a dish on a date (idempotent). */
export function serveDish(dishId: number, dateIso: string): Promise<void> {
  return getMenuStore().serveDish(dishId, dateIso);
}

/** Remove a dish from a day's Menu du Jour (does not delete the dish). */
export function unserveDish(dishId: number, dateIso: string): Promise<void> {
  return getMenuStore().unserveDish(dishId, dateIso);
}

/** Re-serve a day's daily dishes onto a target day (the WP "Reproduire"). */
export function reproduceDay(srcDate: string, toDate: string): Promise<number> {
  return getMenuStore().reproduceDay(srcDate, toDate);
}

/** Atomically replace a day's Menu du Jour with exactly `dishIds` (empty = clear it). */
export function setDayServings(dateIso: string, dishIds: number[]): Promise<number> {
  return getMenuStore().setDayServings(dateIso, dishIds);
}
